export default __webpack_public_path__ + "static/media/bank-uploads-icon.419232aa.svg";